const solutions = {
  'Software Backup': 'backup',
  'Software Escrow': 'escrow',
  'SaaS Escrow': 'saas',
  'Continuity Escrow': 'continuity',
  'AI Escrow': 'ai-escrow',
};

export const mapSolutionNameToType = (name: string) =>
  Object.entries(solutions).find(([key]) => name.toLowerCase().includes(key.toLowerCase()))?.[1];
